export interface EffectMeta {
  id: string;
  label: string;
  keywords: string;
  // One-line, factual description of what actually happens when this effect
  // is triggered — derived from reading each effect component, not invented.
  blurb: string;
  // True for the effects App.tsx's handleTriggerEffect disables outright
  // under prefers-reduced-motion (returns early, doing nothing at all)
  // rather than degrading — see the matching `window.matchMedia(...)`
  // checks there for black-hole, enable-gravity and chidori-rasengan.
  disabledOnReducedMotion?: boolean;
}

// Single source of truth for the site's playful/experimental effects —
// shared by CommandPalette (which lists them as hidden commands) and
// Funhouse (which lists them openly as clickable tiles).
export const EFFECTS: EffectMeta[] = [
  {
    id: 'upside-down',
    label: 'Upside Down',
    keywords: 'upside down stranger things flip dimension portal mirror rift',
    blurb:
      'The page slides away and a decayed, red-tinted copy of it drops in from above. Then it flips back.',
  },
  {
    id: 'gravity-lens',
    label: 'Gravity Lens',
    keywords: 'gravity lens black hole cursor warp singularity gravitational horizon toggle',
    blurb:
      'A lens follows your cursor and bends the page behind it, like light warping around a black hole. Needs a mouse, so it stays off on touch screens and with reduced motion on.',
  },
  {
    id: 'black-hole',
    label: 'Spawn a Black Hole',
    keywords: 'spawn a black hole gargantua singularity eat consume destroy',
    blurb: 'Click anywhere to spawn a black hole. It pulls the page apart and eats it piece by piece.',
    disabledOnReducedMotion: true,
  },
  {
    id: 'golden-snitch',
    label: 'Release the Snitch',
    keywords: 'snitch golden snitch quidditch harry potter seeker catch release recall disarm dismiss',
    blurb: 'A golden Snitch darts around the screen and dodges your cursor. Get close enough to catch it.',
  },
  {
    id: 'enable-gravity',
    label: 'Enable Gravity',
    keywords: 'enable gravity google drop fall physics playground drag toss everything falls',
    blurb: 'Everything on the page falls under real gravity. You can drag the pieces around.',
    disabledOnReducedMotion: true,
  },
  {
    id: 'chidori-rasengan',
    label: 'Chidori vs Rasengan',
    keywords:
      'chidori rasengan naruto sasuke clash jutsu anime lightning valley of the end ninja shinobi',
    blurb: 'Chidori and Rasengan clash across the screen, then the page comes back.',
    disabledOnReducedMotion: true,
  },
];
